import { fetchItemSummariesIfNeeded } from '@/redux/modules/item/summary/itemSummary.actions';
import {
    fetchRecommendedSimilarItems,
    getRecommendedSimilarItemIdsFromState,
} from '@/redux/modules/recommendedSimilarItems';
import { DataLoaderParams } from '@/types/DataLoaderParams';

export default ({ store }: DataLoaderParams) => {
    const { dispatch, getState } = store;

    const fetchRecommendedItems = dispatch(fetchRecommendedSimilarItems({ shouldUseLastTwoViewedLots: true }));

    return fetchRecommendedItems.then(() => {
        const state = getState();
        const itemIds = getRecommendedSimilarItemIdsFromState(state, 0);
        return dispatch(
            fetchItemSummariesIfNeeded({
                identifier: 'RECOMMENDED-ITEMS-PAGE',
                itemIds,
            })
        );
    });
};
